import React from "react";
import "./Resources.css";
import resourceImg1 from "../../Images/resourceImg41.jpg";
import resourceImg2 from "../../Images/resourceImg31.png";
import resourceImg3 from "../../Images/resourceImg21.jpeg";
import resourceImg4 from "../../Images/resourceImg4.webp";
import resourceImg5 from "../../Images/resourceImg5.webp";
import resourceImg6 from "../../Images/resourceImg6.webp";
import resourceVideo1 from "../../Images/resourceVideo1.mp4";

const Resources = () => {
  return (
    <div className="resources-page">
      {/* Hero Section */}
      <section className="hero">
        <h1>Powerful Resources to Accelerate Your Career</h1>
<p>
Discover expert guides, insightful blogs, interactive webinars, and practical videos 
designed to sharpen your skills and boost your confidence for real-world success.
</p>

        <input
          type="text"
          placeholder="Search resources..."
          className="search-bar"
        />
      </section>
      <section className="guidSection">
  <div className="guidText">
    <h2>Career Guides</h2>
    <p>
      Empower students with clear, step-by-step guides tailored to every stage of their journey. 
      From choosing the right path to excelling in their field, our resources turn ambition into action.
    </p>
  </div>

  <div className="guidBlock">
    <div className="guidCard">
      <img src={resourceImg1} alt="Career Myths & Realities" />
      <div className="guidCardText">
        <h3>Career Myths & Realities</h3>
        <p>Bust common misconceptions (e.g., “Arts has no scope”) and discover the truth about career choices.</p>
        <button><a href="/">Read more</a></button>
      </div>
    </div>

    <div className="guidCard">
      <img src={resourceImg2} alt="Resume & Interview Tips" />
      <div className="guidCardText">
        <h3>Resume & Interview Tips</h3>
        <p>Learn how to craft a winning resume and ace interviews with confidence.</p>
        <button><a href="/">Read more</a></button>
      </div>
    </div>

    <div className="guidCard">
      <img src={resourceImg3} alt="Career Growth Roadmap" />
      <div className="guidCardText">
        <h3>Career Growth Roadmap</h3>
        <p>Get step-by-step guidance to upskill, grow, and reach your long-term career goals.</p>
        <button><a href="/">Read more</a></button>
      </div>
    </div>
  </div>
</section>

      <section className="blogSection">
        <div className="blogText">
          <h2>Career Blogs</h2>
          <p>
            Explore expert advice, hiring trends, and actionable tips to help
            you build a confident, scam-free career journey—whether you're just
            starting out or planning your next move.
          </p>
        </div>
        <div className="blogBlock">
          <div className="blogCard">
            <img src={resourceImg5} alt="resourceImg1" />
            <div className="blogCardText">
              <h3>How to Optimize Your LinkedIn Profile</h3>
              <p>
                Step-by-step guide to writing a strong headline, summary, and
                experience section. Learn how to use SEO and keywords to attract
                recruiters
              </p>
            </div>
          </div>
          <div className="blogCard">
            <img src={resourceImg4} alt="resourceImg1" />
            <div className="blogCardText">
              <h3>Get Your Software Developer Resume Noticed</h3>
              <p>
                Learn how to use long tail keywords like “React.js SPA for
                edtech platform” to pass ATS filters and match job descriptions.
                Includes tech stack examples, formatting tips, and resume trends
                to boost visibility.
              </p>
            </div>
          </div>
          <div className="blogCard">
            <img src={resourceImg6} alt="resourceImg1" />
            <div className="blogCardText">
              <h3>Final Round Interview: What to Expect</h3>
              <p>
                Understand common questions asked in final interviews,
                especially at startups. Learn how to answer confidently and
                avoid common mistakes
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="WebinarSection">
        <div className="WebinarText">
          <h2>Career Webinars</h2>
          <p>
            Explore upcoming and past webinars that offer career guidance,
            interview tips, and industry insights—presented in a clean,
            text-based format with speaker bios, key takeaways, and downloadable
            summaries.
          </p>
        </div>
        <div className="WebinarBlock">
          <div className="WebinarCard">
            <video controls width="100%">
              <source src={resourceVideo1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="WebinarCardText">
              <h3>How to Build a Career in Data Analytics</h3>
            </div>
          </div>
          <div className="WebinarCard">
            <video controls width="100%">
              <source src={resourceVideo1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="WebinarCardText">
              <h3>Resume Building for IT & Non-IT Roles</h3>
            </div>
          </div>
          <div className="WebinarCard">
            <video controls width="100%">
              <source src={resourceVideo1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="WebinarCardText">
              <h3>Crack Your First Job Interview: Tips for Freshers</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="resourceJobSection">
  <div className="resourceJobText">
    <h2>Jobs & Career</h2>
    <p>
      Explore powerful resources designed to guide students beyond textbooks. 
      Instead of traditional YouTube content, we provide curated videos, infographics, 
      and expert insights to help you master job search strategies, career planning, 
      and real-world industry expectations.
    </p>
  </div>

  <div className="resourceJobBlock">
    <div className="resourceJobCard">
      <video controls width="100%">
        <source src={resourceVideo1} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="resourceJobCardText">
        <h3>How to Build a Career in Data Analytics</h3>
        <p>Step into the world of data and learn how to become job-ready in this booming industry.</p>
      </div>
    </div>

    <div className="resourceJobCard">
      <video controls width="100%">
        <source src={resourceVideo1} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="resourceJobCardText">
        <h3>Mastering Job Interviews</h3>
        <p>Discover tips, tricks, and proven strategies to crack interviews with confidence.</p>
      </div>
    </div>

    <div className="resourceJobCard">
      <video controls width="100%">
        <source src={resourceVideo1} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="resourceJobCardText">
        <h3>Career Growth in IT & Non-IT</h3>
        <p>Understand the skills, mindset, and roadmap to excel in both IT and Non-IT sectors.</p>
      </div>
    </div>
  </div>
</section>

      {/* Call to Action */}
      <section className="cta-section">
        <h2>Want personalized training & placement support?</h2>
        <button className="cta-btn">
          <a href="/contact">Join Now</a>
        </button>
      </section>
    </div>
  );
};

export default Resources;
